import Cookies from "js-cookie";
import { useTranslation } from "react-i18next";
import { Alert } from "../Alert";
import { useState } from "react";
import { useEffect } from "react";
import { zoneWidgets } from "../../api";

const AutomationWidgets = (props) => {
  const { zoneCaption, setAutomationCommand, id, automationId } = props;
  const token = Cookies.get("token");
  const [title, setTitle] = useState("");
  const { t } = useTranslation();
  const [dashboardDetail, setDashboardDetail] = useState([]);
  const [tooltipText, setTooltipText] = useState("");
  const [widgetIndex, setWidgetIndex] = useState("");
  const [widgetId, setWidgetId] = useState("");
  const [isClicked, setIsClicked] = useState(false);

  useEffect(() => {
    setDashboardDetail([]);
    var data = new FormData();
    data.append("zone", id);
    zoneWidgets(data, token)
      .then((result) => {
        setDashboardDetail(result.data.data);
      })

      .catch((error) => {
        if (error.response.status === 403) {
          setShowAlert((prevState) => ({
            ...prevState,
            show: true,
            message: t("خطایی رخ داده است . لطفا مجددا امتحان کنید."),
            type: "Error",
          }));
          setTimeout(() => {
            setShowAlert((prevState) => ({
              ...prevState,
              show: false,
            }));
          }, 2000);
        }
      });
  }, []);

  const [showAlert, setShowAlert] = useState({
    show: false,
    message: "",
    type: "",
  });

  const toggleAlert = () => {
    setShowAlert((prevState) => ({
      ...prevState,
      show: false,
    }));
  };

  // const handleOnOffWidget = (widget, command, uid, serial, caption) => {
  //   setAutomationCommand((prevAutomationCommand) => [
  //     ...prevAutomationCommand,
  //     { caption, command, widget, serial, uid: automationId },
  //   ]);

  const handleOnOffWidget = (caption, command, id, serial) => {
    setAutomationCommand((prev) => {
      console.log(prev);
      return [
        ...prev,
        {
          caption: { caption },
          command: { command },
          id: { id },
          serial: { serial },
        },
      ];
    });

    setShowAlert((prevState) => ({
      ...prevState,
      show: true,
      question: false,
      message: caption + t("با موفقیت اضافه شد."),
      type: "Success",
    }));
    setTimeout(() => {
      setShowAlert((prevState) => ({
        ...prevState,
        show: false,
      }));
    }, 2000);

    setTimeout(() => {
      setTooltipText("");
    }, 2000);
    setIsClicked(true);
  };

  const widgetClicked = (value, index) => {
    setWidgetIndex(index);
    setWidgetId(value.id);
    setIsClicked(false);
  };

  return (
    <div>
      <small className="d-flex fixed-title justify-content-center text-center mx-auto mb-4 mt-2">
        {t("رویداد های مورد نظر خود را انتخاب نمایید")}
      </small>
      <h6 className="fixed-title text-center mx-auto">
        {t("ناحیه : ") + zoneCaption}
      </h6>
      <div style={{ height: "90vh" }} className="scroll">
        {dashboardDetail?.map((item, index) => {
          let active = widgetIndex === index ? "selectZonesActive" : "";
          let display = widgetIndex === index ? "d-flex" : "d-none";

          return (
            <div key={index}>
              <div
                className={`selectZones text-center py-3 my-2 cursor ${active}`}
                onClick={() => {
                  widgetClicked(item, index);
                }}
              >
                <p className="m-0 fn">{item.caption}</p>
              </div>

              <div>
                <div
                  className={`${display} d-flex justify-content-center align-items-center  `}
                >
                  <button
                    className="commandselect ml-4"
                    onClick={() =>
                      handleOnOffWidget(
                        item.caption,
                        item.commands[0].command,
                        item.uid,
                        item.serial

                        // item.caption,
                        // item.commands[0].command,
                        // item.uid,
                        // item.serial
                      )
                    }
                  >
                    {item.commands[0].command === "10"
                      ? t("خروجی 1 - روشن")
                      : t("خروجی 1 - خاموش")}
                  </button>
                  <button
                    className="commandselect mx-2"
                    onClick={() =>
                      handleOnOffWidget(
                        item.caption,
                        item.commands[1].command,
                        item.uid,

                        // item.uid,
                        item.serial
                      )
                    }
                    data-toggle="tooltip"
                  >
                    {item.commands[1].command === "10"
                      ? t("خروجی 1 - روشن")
                      : t("خروجی 1 - خاموش")}
                  </button>
                </div>
                {tooltipText && (
                  <div className="toast-tooltip ">{tooltipText}</div>
                )}
              </div>
            </div>
          );
        })}
      </div>
      {showAlert.show && (
        <Alert
          message={showAlert.message}
          type={showAlert.type}
          title={title}
          question={showAlert.question}
          request={showAlert.request}
          toggleAlert={toggleAlert}
        />
      )}
    </div>
  );
};

export { AutomationWidgets };
